import type { ErrorEvent, EventHint } from '@sentry/types';

const NOISE_PATTERNS: RegExp[] = [
  /^Loading chunk \d+ failed/i,
  /^Loading CSS chunk \d+ failed/i,
  /ResizeObserver loop/i
];

const messageFrom = (event: ErrorEvent, hint?: EventHint): string => {
  const fromHint = (hint?.originalException as Error | undefined)?.message;
  if (fromHint) return fromHint;
  return event.exception?.values?.[0]?.value ?? '';
};

export const beforeSend = (
  event: ErrorEvent,
  hint?: EventHint
): ErrorEvent | null => {
  const msg = messageFrom(event, hint);
  if (NOISE_PATTERNS.some((re) => re.test(msg))) return null;
  return event;
};
